import React from 'react';
import { infoData } from './infoData';

const Info = () => {
  return (
    <div className="about__info">
      {infoData.map(({ id, icon, title, subtitle }) => (
        <div key={id} className="about__box">
          <i className={`bx ${icon} about__icon`}></i>
          <h3 className="about__title">{title}</h3>
          <span className="about__subtitle">{subtitle}</span>
        </div>
      ))}
    </div>
  );
};

export default Info;
